// Fresh-eyes item 21 (Carla, 2026-10-12): a list page on a phone starts with its search; the tag,
// status, sort and view controls go behind ONE "Filter" button that opens a sheet, so the first item
// shows without scrolling (390x844). Whatever is applied is named in a slim line under the search,
// so a narrowed list never looks like the whole list. Tablet and desktop keep their own toolbars:
// a page renders this only on a phone.
//
//   search   the page's own <SearchInput> (it stays the page's, with its label and state)
//   active   the names of the filters now applied (not the defaults), e.g. ['Lead', 'Name A to Z']
//   title    the sheet's title, e.g. "Filter contacts"; done: its button, e.g. "Show contacts"
//   children the page's own controls, unchanged, inside the sheet
import React, { useState } from 'react';
import { Button, Sheet } from '../../ui';
import './phoneList.css';

export default function PhoneListFilters({ search, active = [], title = 'Filter', done = 'Done', children }) {
  const [open, setOpen] = useState(false);
  const n = active.length;
  return (
    <div className="plf" data-testid="list-filters">
      <div className="plf__bar">
        <div className="plf__search">{search}</div>
        <Button variant="secondary" className="plf__btn" aria-haspopup="dialog" onClick={() => setOpen(true)}
          aria-label={n ? `Filter, ${n} on` : 'Filter'}>
          Filter{n ? <span className="plf__count" aria-hidden="true">{n}</span> : null}
        </Button>
      </div>
      {n > 0 && <p className="plf__active" data-testid="list-filters-active">{active.join(' · ')}</p>}
      <Sheet open={open} onClose={() => setOpen(false)} title={title}
        footer={<Button variant="confirm" block onClick={() => setOpen(false)}>{done}</Button>}>
        <div className="plf__controls">{children}</div>
      </Sheet>
    </div>
  );
}
